import { NotificationBell } from '../notifications/NotificationBell';
import { GlobalOmnibox } from '../omnibox/GlobalOmnibox';
import { AccountMenu } from './AccountMenu';

/**
 * Desktop content header; the sidebar owns the brand and practice identity.
 * Controls float above the scroller; empty header space passes pointer events
 * through to the page. Keep this header out of a stacking context so the open
 * omnibox input can sit above its portaled scrim.
 *
 * The backdrop fades in once the scroller leaves the top (`data-scrolled`, set
 * by the layout), so content does not show through between the controls. It
 * sits above the page's z-10 sticky headers and below the z-30 controls.
 */
export function TopBar() {
  return (
    <header className="pointer-events-none absolute inset-x-0 top-0 hidden h-14 grid-cols-[minmax(0,1fr)_minmax(0,380px)_minmax(0,1fr)] items-center lg:grid">
      <div
        aria-hidden="true"
        className="absolute inset-0 z-20 border-b border-border bg-bg-subtle opacity-0 transition-opacity duration-150 group-data-[scrolled=true]/content:opacity-100"
      />
      <div aria-hidden="true" />
      <div className="pointer-events-auto min-w-0">
        <GlobalOmnibox variant="desktop" />
      </div>
      <div className="relative z-30 mr-6 flex items-center gap-3 justify-self-end [&>button]:pointer-events-auto">
        <NotificationBell />
        <AccountMenu />
      </div>
    </header>
  );
}
